<ion-row>
  <app-year-selection #yearSelection
                      (yearSelectionChanged)="onYearChanged($event)"
                      [defaultDate]="defaultDate">
  </app-year-selection>
</ion-row>
<ion-row>
  <ion-radio-group *ngIf="isQuartalSelectionEnabled"
    class="ion-padding-top"
    value="quartalselection"
    [(ngModel)]="selectedYearInfo"
    (ionChange)="onRadioChange()">

    <ion-radio
      [value]="choices.full"
      labelPlacement="end"
      class="ion-margin-end"
      [disabled]="radioDisabled$ | async"
      (click)="stop($event, choices.full)">
      {{ texts.report.fullYear | translate }}
    </ion-radio>

    <ion-radio
      [value]="choices.Q1"
      labelPlacement="end"
      class="ion-margin-end"
      [disabled]="radioDisabled$ | async"
      (click)="stop($event, choices.Q1)">
      Q1
    </ion-radio>

    <ion-radio
      [value]="choices.Q2"
      labelPlacement="end"
      class="ion-margin-end"
      [disabled]="radioDisabled$ | async"
      (click)="stop($event, choices.Q2)">
      Q2
    </ion-radio>

    <ion-radio
      [value]="choices.Q3"
      labelPlacement="end"
      class="ion-margin-end"
      [disabled]="radioDisabled$ | async"
      (click)="stop($event, choices.Q3)">
    Q3
  </ion-radio>

    <ion-radio
      [value]="choices.Q4"
      labelPlacement="end"
      class="ion-margin-end"
      [disabled]="radioDisabled$ | async"
      (click)="stop($event, choices.Q4)">
    Q4
  </ion-radio>
  </ion-radio-group>
</ion-row>
